import { createStyles, WithStyles, withStyles } from "@material-ui/styles";
import { Theme, Paper } from "@material-ui/core";
import * as React from "react";
import Footer from "../../layouts/Footer";
import Header from "../../layouts/Header";
import Layout from "../../layouts/Layout";
import RecentlyUsedSlides from "../../components/RecentlyUsedSlides";
import TablePricesWidget from "../../modules/prices/containers/TablePricesWidget/TablePricesWidget";
import NewsArgicultureWidget from "../../modules/news/containers/ArgicultureWidget/ArgicultureWidget";
import { HomeNavigationBlocks } from "../../modules/navigation";
import RecentlyFavourites from "../../components/RecentlyFavourites";

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    content: {
      paddingTop: 72,
      paddingBottom: 16,
      paddingLeft: 32,
      paddingRight: 32,
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#F5F5F5",
    },
    centerSide: {
      width: "100%",
    },
    bottomSide: {
      display: "flex",
      width: "100%",
      paddingTop: 24,
      overflow: "hidden",
    },
    leftSide: {
      display: "flex",
      width: "100%",
      "& > div~div": {
        paddingLeft: 16,
      },
    },
    rightSide: {
      marginBottom: 40,
      marginLeft: 20,
      display: "flex",
      flex: "1 1 50%",
      width: "50%",
      padding: 0,
      backgroundColor: "inherit",
      boxShadow: "inherit",
    },
    papper: {
      flex: "1 1 50%",
      display: "flex",
      width: "50%",
      minWidth: 536,
      padding: 12,
      marginBottom: 40,
      backgroundColor: "inherit",
      boxShadow: "inherit",
    },
    navigationBlocks: {
      paddingTop: 24,
    },
  });

type Props = WithStyles<typeof styles>;

class HomePage extends React.Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <Layout>
        <Header />
        <div className={classes.content}>
          <div className={classes.navigationBlocks}>
            <HomeNavigationBlocks />
          </div>
          <div className={classes.centerSide}>
            <RecentlyFavourites />
          </div>
          <div className={classes.centerSide}>
            <RecentlyUsedSlides />
          </div>
          <div className={classes.bottomSide}>
            <Paper className={classes.papper}>
              <div className={classes.leftSide}>
                <TablePricesWidget />
              </div>
            </Paper>
            <Paper className={classes.rightSide}>{<NewsArgicultureWidget />}</Paper>
          </div>
        </div>
        <Footer />
      </Layout>
    );
  }
}

export default withStyles(styles)(HomePage);
